import { NgxMaskDirective } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { MatIconModule } from '@angular/material/icon';
import { ConfirmationBoxTypeComponent } from './confirmation-box-type.component';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LetDirective } from '@ngrx/component';

@NgModule({
  declarations: [ConfirmationBoxTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    FormlyModule.forChild({
      types: [
        {
          name: 'confirmation-box',
          component: ConfirmationBoxTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    UiModule,
    MatIconModule,
    MatCheckboxModule,
    LetDirective,
  ],
})
export class ConfirmationBoxTypeModule {}
